<!-- 
  详情页 - 负责人部门
  props:
    id: 详情产品id
  emit:暂无
 -->
 <template>
  <div class="person-tab">
    <h1 class="theme"><i></i><span>负责部门</span></h1>
    <div class="departOut">
      <ul class="departmentList">
        <el-button class="el-icon-minus" @click="showDel(1)"
         v-clickoutside="hideDel"></el-button>
        <el-button class="el-icon-plus" @click="openPerson(1)"></el-button>
        <li v-for="(dep,d) in departmentArray">
          <div class="imgOut">
            <i class="dep el-icon-menu"></i>
            <i class="el-icon-circle-close" v-show="showCloseDep" @click="delperson(dep.relationId, d, 'department')"></i>
          </div>
          <p>{{dep.userName}}</p>
        </li>
      </ul>
    </div>
    <h1 class="theme"><i></i><span>负责人</span></h1>
    <ul class="personList">
      <el-button class="el-icon-minus" @click="showDel(0)"
      v-clickoutside="hideDel"></el-button>
      <el-button class="el-icon-plus" @click="openPerson(0)"></el-button>    
      <li v-for="(sta,s) in staffArray">
        <div class="imgOut">
          <img v-if="sta.userAvatar !== '/images/default.jpg'" :src="sta.userAvatar"/>
          <i v-else class="per">{{sta.userName.substr(sta.userName.length - 2)}}</i>
          <i class="el-icon-circle-close" v-show="showClosePer" @click="delperson(sta.relationId, s, 'user')"></i>
        </div>
        <p>{{sta.userName}}</p> 
      </li>
    </ul>
    <product-person
      v-if="personDialog" 
      :id="idArr"
      :type="type"
      @closeDialog="closeDialog"
      @refresh="refresh">
    </product-person>
  </div>
</template>
<script>
import * as api from 'src/api'
// 产品分配负责人或者部门
import productPerson from 'components/detail/product/product-person'
import { Message } from 'element-ui'
import Clickoutside from 'element-ui/lib/utils/clickoutside'
export default {
  created () {
    this.getPersonDepartment()
  },
  props: {
    id: {
      type: Number
    }
  },
  data () {
    return {
      personDialog: false, // 弹框显隐
      staffArray: [], // 员工数组
      departmentArray: [], // 部门数组
      showCloseDep: false, // 部门删除图标
      showClosePer: false, // 员工删除图标
      type: 1 // 员工0部门1
    }
  },
  computed: {
    // 获取产品id放到数组里
    idArr () {
      let arr = []
      arr.push(this.id)
      return arr
    }
  },
  methods: {
    // 产品负责人和部门
    getPersonDepartment () {
      this.staffArray = []
      this.departmentArray = []
      let url = `/productApi/getProductUserRelation.html`
      let params = {
        productId: this.id
      }
      api.post(url, params, (data) => {
        let managerList = data.managerList // 获取员工和部门数组
        console.log(managerList)
        managerList.forEach((item) => {
          if (item.type === 1) {
            this.departmentArray.push(item)
          }
          if (item.type === 0) {
            this.staffArray.push(item)
          }
        })
      })
    },

    // 删除图标显示
    showDel (type) {
      if (type === 1) {
        this.showCloseDep = !this.showCloseDep
      } else {
        this.showClosePer = !this.showClosePer
      }
    },

    // 点除此之外其他区域隐藏删除图标
    hideDel () {
      this.showCloseDep = false
      this.showClosePer = false
    },

    // 删除已分配的人和部门
    delperson (id, index, type) {
      if (type === 'department') {
        this.departmentArray.splice(index, 1)
      } else if (type === 'user') {
        this.staffArray.splice(index, 1)
      }
      let url = `/productApi/deleteProductUserRelation.html`
      let params = {
        productId: this.id,
        relationId: id,
        distributionType: type
      }
      api.post(url, params, (data) => {
        if (data.code === 1) {
          Message({
            type: 'success',
            message: data.msg
          })
        } else {
          Message({
            type: 'error',
            message: data.msg
          })
        }
      })
    },

    // 监听弹框关闭（包含部门、负责人）
    closeDialog () {
      this.personDialog = false
    },

    // 子组件返回刷新父组件
    refresh (val) {
      this.getPersonDepartment()
    },

    // 打开负责人
    openPerson (type) {
      if (type === 1) {
        this.type = 1
      } else {
        this.type = 0
      }
      this.personDialog = true
    }
  },
  watch: {
  },
  components: {
    productPerson
  },
  directives: {
    Clickoutside
  }
}
</script>
<style lang="less">
  .person-tab{
    .el-button.el-icon-plus,.el-button.el-icon-minus {
    border-radius: 30px;
    width: 30px;
    height: 30px;
    padding: 0;
    background: #E8EDF4;
    border: none;
    color: #95A8C2;float:right;}
    .el-button.el-icon-plus{margin-right:10px;margin-left: 0;}
  }
</style>
<style lang="less" scoped>
  .person-tab{
    padding:0 15px;
    .theme{background:#F1F6FE;line-height: 30px;font-size:13px;}
    .theme i{display:inline-block;width:8px;height:8px;background:#FF943E;margin:0 10px;}
    .departmentList,.personList{margin:15px 0;
      margin-left: 28px;
      display:inline-block;}
    .departmentList li,.personList li{float:right;margin-right:10px;text-align: center;}
    .departmentList li i.dep,.departmentList li img{display:inline-block;text-align: center;width:30px;height:30px;border-radius: 30px;background:#59b9fc;color:#fff;line-height: 30px;}
    .personList li i.per,.personList li img{display:inline-block;text-align: center;width:30px;height:30px;border-radius: 30px;background:#78919d;color:#fff;line-height: 30px;font-style: normal;}
    .personList li .imgOut,.departmentList li .imgOut{
      position: relative;
      isplay:inline-block;text-align: center;width:30px;height:30px;border-radius: 30px;
      margin: 0 auto;
    }
    .personList li i.el-icon-circle-close,.departmentList li i.el-icon-circle-close{
      font-size: 16px;
      cursor: pointer;
      color:#ff6161;
      position: absolute;
      top: -5px;
      right: -5px;
      background: #fff;
      border-radius: 50%;
    }
  }
</style>


// WEBPACK FOOTER //
// person-tab.vue?0178d849